import { render, staticRenderFns } from "./ProfitLoss.vue?vue&type=template&id=463a8705&scoped=true"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./ProfitLoss.vue?vue&type=style&index=0&id=463a8705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a8705",
  null
  
)

export default component.exports